module.exports = __webpack_public_path__ + "static/media/cy.59aa3a04.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/cy.svg
// module id = 631
// module chunks = 0